import LegalPage from "@/pages/legal/LegalPage";
import { Mail, LifeBuoy, CreditCard, ShieldAlert } from "lucide-react";

export default function Contact() {
  return (
    <LegalPage title="Contact Us" updated="February 5, 2026">
      <p>
        We read every message. Please use the right address so we can route your question
        to the right team.
      </p>

      <div className="not-prose mt-6 space-y-3">
        <ContactCard
          icon={<LifeBuoy size={18} />}
          title="General support"
          desc="Questions, bug reports, feedback about the app"
          email="support@imrsvprtl.com"
          testId="contact-support"
        />
        <ContactCard
          icon={<CreditCard size={18} />}
          title="Billing &amp; subscriptions"
          desc="Immersive+ questions, refund requests, payment issues"
          email="billing@imrsvprtl.com"
          testId="contact-billing"
        />
        <ContactCard
          icon={<ShieldAlert size={18} />}
          title="Privacy &amp; data requests"
          desc="Access, correction, or deletion of your personal data"
          email="privacy@imrsvprtl.com"
          testId="contact-privacy"
        />
        <ContactCard
          icon={<Mail size={18} />}
          title="Legal &amp; press"
          desc="Trademark notices, legal inquiries, media requests"
          email="legal@imrsvprtl.com"
          testId="contact-legal"
        />
      </div>

      <h2>Business Information</h2>
      <p>
        <strong>Immersive Character AI</strong><br />
        Operating from Texas, United States of America<br />
        Website: <a href="https://imrsvprtl.com">https://imrsvprtl.com</a>
      </p>

      <h2>Report Illegal Content</h2>
      <p>
        If you encounter content on the Service that depicts minors in a sexual context,
        non-consensual acts, or other illegal material, please report it immediately to{" "}
        <a href="mailto:trust@imrsvprtl.com">trust@imrsvprtl.com</a>. We take these reports
        seriously and cooperate with law enforcement.
      </p>

      <h2>Response Time</h2>
      <p>
        We aim to respond within <strong>2 business days</strong> for general inquiries and
        within <strong>24 hours</strong> for billing or account access issues. Privacy
        requests are responded to within 30 days as required by law.
      </p>

      <p className="mt-8 text-neutral-500 text-xs italic">
        Please do not send confidential information (passwords, payment card numbers, etc.)
        in an email. Our support staff will never ask you to share your password.
      </p>
    </LegalPage>
  );
}

function ContactCard({ icon, title, desc, email, testId }) {
  return (
    <div
      className="rounded-2xl border border-white/10 bg-white/[0.03] p-4"
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-violet-500/15 text-violet-300">
          {icon}
        </div>
        <div className="flex-1">
          <div className="font-display text-base text-white">{title}</div>
          <div className="mt-0.5 text-xs text-neutral-400">{desc}</div>
          <a
            href={`mailto:${email}`}
            className="mt-2 inline-block text-sm text-violet-300 hover:text-violet-200"
          >
            {email}
          </a>
        </div>
      </div>
    </div>
  );
}
